import { useState, useRef, useEffect } from 'react'

import { useRouter } from 'next/router'

import { getAdTag, getCountryAdTag } from '../../../utils/ads'
import { PubliftAd } from '../publiftAd'
import { AdBlock } from './index'
import { StyledFixedAdBlock } from './index.styled'

export type Props = {
  className?: string
  isMobile?: boolean
  divId?: string
  adUnitPath?: string
  contentId?: string
  dataFuse?: string
  customTargetings?: { [key: string]: (string | number) | (string | number)[] }
}

const FixedBottomAdBlock = ({
  className,
  adUnitPath,
  divId,
  isMobile,
  contentId,
  dataFuse,
  customTargetings,
}: Props) => {
  const { locale = 'vi-VN' } = useRouter()
  const [hideAd, setHideAd] = useState(false)
  const adRef = useRef<HTMLDivElement>(null)
  const timeoutRef = useRef<any>(null)
  const checkHideAd = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => {
      if (document.getElementById('subot--container')) {
        setHideAd(true)
      } else {
        setHideAd(false)
      }
      checkHideAd()
    }, 5000)
  }
  useEffect(() => {
    if (isMobile) {
      setHideAd(true)
      checkHideAd()
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [isMobile])
  if (hideAd) return null
  return (
    <StyledFixedAdBlock className={className}>
      {!dataFuse ? (
        <AdBlock
          key={isMobile ? 'mobile' : 'desktop'}
          ref={adRef}
          adUnitPath={
            adUnitPath ||
            getAdTag({
              countryAdTag: getCountryAdTag(locale, {
                isMobile,
              }),
              forceTag: 'sticky',
            })
          }
          size={
            isMobile
              ? [
                  [320, 50],
                  [320, 100],
                ]
              : [728, 90]
          }
          divId={(divId || 'div-gpt-ad-sticky') + (isMobile ? '-mobile' : '')}
          pos={['Sticky']}
          contentId={contentId}
          customTargetings={customTargetings}
          refreshInterval={30}
        />
      ) : (
        <PubliftAd
          dataFuse={dataFuse}
          targeting={{
            Pos: ['Sticky'],
            Content_ID: contentId || '',
            ...customTargetings,
          }}
        />
      )}
      <div className="close-sticky-button" onClick={() => setHideAd(true)}>
        x
      </div>
    </StyledFixedAdBlock>
  )
}

export { FixedBottomAdBlock }
